import { TitleBodyStyle } from "./style"

interface Props {
    children: React.ReactNode;
}

export const TitleBody: React.FC<Props> = ({ children }) => {
    return (
        <TitleBodyStyle>
            {children}
        </TitleBodyStyle>
    )
}